import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "@/views/MainPage/MainPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: MainPage,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,

  // permite deep-link direto para uma seção: /#projects
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, behavior: "smooth" };
    }
    return savedPosition || { x: 0, y: 0 };
  },
});

export default router;
